import { useQuery } from '@tanstack/react-query';
import { onboardingApi } from '@/api/onboarding';
import { queryKeys } from '@/lib/query-keys';
import { useTenantId } from '@/providers/TenantProvider';

export function useOnboardingState() {
  const tenantId = useTenantId();
  return useQuery({
    queryKey: queryKeys.onboarding.state(tenantId),
    queryFn: () => onboardingApi.getState(tenantId),
    enabled: !!tenantId,
  });
}
